// 광고 한 번의 순서 — 발급 → 시청 → 청구 (prd/112 Story 10, INV-005)
//   1. 광고를 열기 직전에 서버에서 티켓을 받는다. 살아 있는 미사용 티켓이 있으면 서버가 그것을 다시 준다
//   2. 광고를 띄운다. 끝까지 봐야 'rewarded'
//   3. 'rewarded' 일 때만 티켓으로 청구한다. 2 가 다르게 끝나면 청구하지 않고, 티켓은 그대로 만료된다
// 보상을 주는 것은 서버다. 이 순서는 서버가 받아 줄 청구만 보내려는 것이지 권한이 아니다

/** 광고 시청의 결말 */
export type AdOutcome = 'rewarded' | 'dismissed' | 'unavailable';

/** 화면이 안내 문구를 고르는 결과 */
export const REWARD_RESULTS = ['credited', 'dismissed', 'unavailable', 'failed'] as const;

/**
 * credited    끝까지 봤고 서버가 보상을 줬다
 * dismissed   광고는 떴는데 유저가 닫았다 — 알릴 것 없음
 * unavailable 광고를 띄우지 못했다(광고 없음·차단기·로드 실패) — 버튼을 눌렀는데 아무 일도 없었으니 알린다
 * failed      티켓 발급이나 청구가 실패했다
 */
export type RewardResult = (typeof REWARD_RESULTS)[number];

export interface RewardSteps {
  /** 티켓 id, 실패면 null */
  issue(): Promise<string | null>;
  show(): Promise<AdOutcome>;
  /** 서버가 보상을 줬으면 true */
  claim(ticket: string): Promise<boolean>;
}

export async function watchForReward(steps: RewardSteps): Promise<RewardResult> {
  const ticket = await steps.issue();
  if (ticket === null) return 'failed';
  const outcome = await steps.show();
  if (outcome !== 'rewarded') return outcome;
  return (await steps.claim(ticket)) ? 'credited' : 'failed';
}
